/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

export const HeadFoot = styled.div`
  align-items: center;
  background-color: transparent;
  border: 1px solid #000;
  display: flex;
  flex-direction: row;
  font-family: Inter, sans-serif;
  height: 40px;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 680px;
`;

export const LDHeaderWrapper = styled(HeadFoot)`
  margin-top: 80px;

  @media (max-width: ${DEVICE.medium}) {
    margin-top: 40px;
    width: 85%;
  }
`;

export const LDFooterWrapper = styled(HeadFoot)`
  justify-content: center;
  margin-bottom: 80px;
  margin-top: 20px;

  @media (max-width: ${DEVICE.medium}) {
    margin-bottom: 40px;
    width: 85%;
    font-size: 12px;
  }
`;
